import {computed} from 'vue';
import {useLocale, useAuth} from '#imports';
import {useFeatureFlag, type FeatureFlagId} from '@malt/feature-flags';

const NEW_UNLOGGED_NAVBAR_FLAG = 'new-unlogged-navbar' as const;
const NEW_UNLOGGED_NAVBAR_MALT_COM_FLAG = 'new-unlogged-navbar-malt-com' as const;

function useHostScopedFeatureFlag(localeFlag: FeatureFlagId, maltComFlag: FeatureFlagId) {
    const {isMultiLocaleHost} = useLocale();
    const localeEnabled = useFeatureFlag(localeFlag);
    const maltComEnabled = useFeatureFlag(maltComFlag);

    return computed(() => (isMultiLocaleHost.value ? maltComEnabled.value : localeEnabled.value));
}

export function useNewUnloggedNavbar() {
    const {loggedIn} = useAuth();
    const showNewUnloggedNavbar = computed<boolean>(
        () => !loggedIn && useHostScopedFeatureFlag(NEW_UNLOGGED_NAVBAR_FLAG, NEW_UNLOGGED_NAVBAR_MALT_COM_FLAG).value,
    );
    return {
        showNewUnloggedNavbar,
    };
}
